import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Image as ImageIcon, X } from 'lucide-react';
import { COLORS } from '../constants';
import { GALLERY_IMAGES } from '../data/gallery';
import { Helmet } from 'react-helmet-async';
import Button from '../components/Button';
import SectionHeading from '../components/SectionHeading';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
 return (
	
    <section className="py-20 min-h-screen" style={{ backgroundColor: COLORS.lightSurface }}>
      <SectionHeading title="Visual Experience" subtitle="Crafted for the green, styled for life." />
      <div className="container mx-auto px-6 columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
        {GALLERY_IMAGES.map((img, idx) => (
          <motion.div 
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "200px" }}
            className="break-inside-avoid rounded-[2rem] overflow-hidden shadow-lg cursor-pointer group relative"
            onClick={() => setSelectedImage(img)}
          >
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 z-10 flex items-center justify-center">
                <ImageIcon className="text-white opacity-0 group-hover:opacity-100 scale-50 group-hover:scale-100 transition-all duration-300" size={48} />
            </div>
            <img src={img} alt={`Gallery ${idx}`} loading="lazy"  decoding="async" className="w-full h-auto transform transition-transform duration-700 group-hover:scale-110" />
          </motion.div>
        ))}
	<>
     <Helmet>
 	 <title>Gallery | Lectric Leisure Golf Scooters</title>
  	<meta name="description" content="See Lectric Leisure scooters in action across golf courses and real customer environments." />
  	<link rel="canonical" href="https://lectricleisure.golf/gallery" />
     </Helmet>
	</>
      </div>
      <AnimatePresence>
        {selectedImage && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button className="absolute top-8 right-8 text-white p-2 hover:rotate-90 transition-transform">
              <X size={48} />
            </button>
            <img src={selectedImage} loading="lazy"  decoding="async" alt="Full view" className="max-h-[90vh] max-w-[90vw] rounded-2xl shadow-2xl" onClick={(e) => e.stopPropagation()} />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default GalleryPage;